const React = require('react');

class Quote extends React.Component {
    render() {
        return <article className="quote" dangerouslySetInnerHTML={{__html: this.props.text}}/>;
    }
}

module.exports = Quote;